import React, { useEffect, lazy, Suspense } from 'react';
import Lenis from '@studio-freight/lenis';
import HeroSection from '../components/sections/HeroSection';
import AboutStatementSection from '../components/sections/AboutStatementSection';

// Lazy load below-the-fold components
const VideoWordsSection = lazy(() => import('../components/sections/VideoWordsSection'));
const ServicesSection = lazy(() => import('../components/sections/ServicesSection'));
const ProjectsSection = lazy(() => import('../components/sections/ProjectsSection'));
const BenefitsSection = lazy(() => import('../components/sections/BenefitsSection'));
const ReachingHeightsSection = lazy(() => import('../components/sections/ReachingHeightsSection'));
const MarketingSection = lazy(() => import('../components/sections/MarketingSection'));
const TeamSection = lazy(() => import('../components/sections/TeamSection'));
const JobsSection = lazy(() => import('../components/sections/JobsSection'));
const ContactSection = lazy(() => import('../components/sections/ContactSection'));

// Simple loading placeholder
const SectionLoader = () => <div className="min-h-[50vh]" />;

export default function HomePage() {
  useEffect(() => {
    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Add lenis class to html
    document.documentElement.classList.add('lenis');

    return () => {
      lenis.destroy();
      document.documentElement.classList.remove('lenis');
    };
  }, []);

  return (
    <main data-testid="homepage">
      {/* Hero - Critical, load immediately */}
      <HeroSection />
      
      {/* About Statement - Critical, load immediately */}
      <AboutStatementSection />
      
      {/* Lazy loaded sections */}
      <Suspense fallback={<SectionLoader />}>
        <VideoWordsSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <ServicesSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <ProjectsSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <BenefitsSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <ReachingHeightsSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <MarketingSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <TeamSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <JobsSection />
      </Suspense>
      
      <Suspense fallback={<SectionLoader />}>
        <ContactSection />
      </Suspense>
    </main>
  );
}
